import {
    Component,
    Input,
    ElementRef,
    ViewChild
} from '@angular/core';

import * as ScreepsMap from '@screeps/map';

@Component({
    selector: 'app-badge',
    templateUrl: './badge.component.pug',
    styleUrls: ['./badge.component.less']
})
export class BadgeComponent {
    @ViewChild('img', {static: true}) img: ElementRef;

    @Input() width: number;

    @Input() set data(data) {
        if (!data) {
            return;
        }

        let { width } = this._ref.nativeElement.getBoundingClientRect();

        width = this.width || width;

        ScreepsMap.generateUserBadge(data, Math.round(width), Math.round(width))
            .then((dataUrl) => {
                this.img.nativeElement.setAttribute('src', dataUrl);
            });
    }

    constructor(
        private _ref: ElementRef
    ) { }
}
